/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {KTIcon, toAbsoluteUrl} from '../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons'

type Props = {
  className: string
  color: string
  svgIcon: string
  iconColor: string
  title: string
  titleColor?: string
  description: string
  descriptionColor?: string
  icon?: any
  link?: any
}

const StatisticsWidget5: React.FC<Props> = ({
  className,
  color,
  svgIcon,
  iconColor,
  title,
  titleColor,
  description,
  descriptionColor,
  icon,
  link,
}) => {
  return (
    <Link to={link} className={`card bg-${color} hoverable ${className} position-relative `}  >
      <img
        alt='images'
        src={toAbsoluteUrl('/media/otherSVG/Mask group (2).svg')}
        className='position-absolute top-0 end-0 w-100'
      />
      <div className='card-body'>
        {title === 'Total Booking' ? (
          
          <FontAwesomeIcon icon={faCircleCheck} className='fontsize35px me-3 themeGreenColor' />
        ) :
        icon !== '' && icon !== null ? (
          <img alt='images' src={toAbsoluteUrl('/media/otherSVG/' + icon)} />
        ) : (
          <KTIcon iconName={svgIcon} className={`text-${iconColor} fs-3x ms-n1 themeGreenColor`} />
        )}

        <div className={`text-${titleColor} fw-bold fs-2 mb-2 mt-5`}>{title}</div>

        <div className={`fw-semibold text-${descriptionColor}`}>{description}</div>
      </div>
    </Link>
  )
}

export {StatisticsWidget5}
